var map = {
	"./Building Omnichannel Retail Excellence for Multi-Store Fashion & Lifestyle Chain.png": 3075,
	"./Modernizing Multi-Partner CA Firm Operations with Integrated Practice Management.png": 8215,
	"./Revolutionizing Production Planning & Quality Control for Export-Focused Textile Mill.png": 7052,
	"./Streamlining Quality Control & Batch Tracking for Mid-Sized Pharmaceutical Manufacturer.png": 4041,
	"./Transforming Patient Care & Operational Efficiency at Mid-Sized Regional Hospital.png": 1843,
	"./Unifying Operations Across Multi-Location Diagnostic & Specialty Clinic Chain.png": 1303
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6630;